module.exports = __webpack_public_path__ + "img/16.72fa27fc.png";